<div class="saved-filters-panel">
  <mat-form-field appearance="outline" class="saved-filters-panel__field">
    <mat-label>Saved filters</mat-label>
    <mat-select
      [value]="value()"
      placeholder="Select saved filter"
      (selectionChange)="onSelectionChange($event.value)"
    >
      <mat-select-trigger>{{ selectedLabel() }}</mat-select-trigger>
      @for (filter of filters(); track filter.id) {
        <mat-option [value]="filter.id" [class.readonly-filter]="filter.readonly">{{
          filter.label
        }}</mat-option>
      }
    </mat-select>
  </mat-form-field>
</div>
